import React from 'react';
import { useJobDetailsNewCollection } from '../../../../../data/jobDetailsNewCollection';
import { useFindJobState } from '../../../../../data/status';
import EmojiFlagText from '../../../../custom-ui/emoji/EmojiFlagText';

interface AppliedJobsRowProps {
    jobId: string;
    appliedData: any;
}

const AppliedJobsRow = ({ jobId, appliedData }: AppliedJobsRowProps) => {
    const { data: job } = useJobDetailsNewCollection(jobId);
    const date = new Date(appliedData.seconds * 1000);
    const usDate = date.toLocaleDateString("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });

    const { data: statusData } = useFindJobState(job?.jobState);

    if (!job?.jobName) return null;

    return (
        <tr className="border-b  bg-white">
            <td className="py-3 px-2">
              <EmojiFlagText>{job?.jobName || ''}</EmojiFlagText>
            </td>
            <td className="py-3px-2">{statusData?.label || ''}</td>
            <td className="py-3 px-2">{usDate || ''}</td>
        </tr>
    );
};

export default AppliedJobsRow;
